import { ACTIVITIES_COMPONENT_SUB_ACTIVITIES_TYPES } from 'global/constants';
import type { GetActivitiesChangesQuery } from '../settings-publish.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export function getChangesForResponseComponents(
  changes: Pluck<GetActivitiesChangesQuery, 'getActivitiesChanges'>[]
) {
  return changes.filter(
    change =>
      ACTIVITIES_COMPONENT_SUB_ACTIVITIES_TYPES.includes(
        change.componentType
      ) && change.numberOfAnswers > 0
  );
}
